import { List } from 'immutable';
import styled from 'styled-components';
// @ts-expect-error bender-url
import browser from 'bender-url!../../img/mock-browser.svg';
import useChatSlice from '../hooks/useChatSlice';
// @ts-expect-error Library not migrated yet
import WidgetData from 'conversations-internal-schema/widget-data/records/WidgetData';
// @ts-expect-error Library not migrated yet
import Message from 'conversations-internal-schema/message/records/Message';
import { buildChatHeadingConfigFromType } from 'conversations-internal-schema/chat-heading-config/builders/buildChatHeadingConfigFromType';
import { COMPANY } from 'conversations-internal-schema/chat-heading-config/constants/ChatHeadingConfigTypes';
import ColoringRecord from 'conversations-internal-schema/coloring/records/ColoringRecord';
// @ts-expect-error Library not migrated yet
import ChatWidgetPreview from 'conversations-visitor-experience-components/presentation-components/chat-widget-preview/ChatWidgetPreview';
import I18n from 'I18n';
import { GRID_BREAKPOINT_EXTRA_LARGE, GRID_BREAKPOINT_LARGE, GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_SMALL } from '../constants/sizes';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "PreviewBox__Container",
  componentId: "sc-1oc2gzs-0"
})(({
  chatOnly
}) => {
  const minWidth = chatOnly ? GRID_BREAKPOINT_LARGE : GRID_BREAKPOINT_EXTRA_LARGE;
  const mediaQuery = `@media screen and (min-width: ${minWidth})`;
  return {
    position: 'relative',
    flexGrow: 1,
    overflow: 'visible',
    padding: '10px 0',
    [mediaQuery]: {
      minHeight: '100%',
      height: 'calc(100vh - 232px)'
    }
  };
});
const Browser = styled.div.withConfig({
  displayName: "PreviewBox__Browser",
  componentId: "sc-1oc2gzs-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    background: `url(${browser})`,
    backgroundSize: '100% 100%',
    border: `1px solid ${theme.color['icon-tertiary-default']}`,
    borderRadius: '20px',
    position: 'relative',
    width: '80%',
    aspectRatio: '600/527',
    overflow: 'hidden'
  };
});
const Website = styled.img.withConfig({
  displayName: "PreviewBox__Website",
  componentId: "sc-1oc2gzs-2"
})(["position:absolute;top:7.6%;left:0;width:100%;"]);
const Wrapper = styled.div.withConfig({
  displayName: "PreviewBox__Wrapper",
  componentId: "sc-1oc2gzs-3"
})(({
  chatOnly
}) => {
  return {
    height: '100%',
    boxSizing: 'content-box',
    paddingLeft: chatOnly ? '15%' : '5%',
    paddingRight: chatOnly ? '15%' : '5%'
  };
});
const BrowserChatWrapper = styled.div.withConfig({
  displayName: "PreviewBox__BrowserChatWrapper",
  componentId: "sc-1oc2gzs-4"
})(["position:absolute;bottom:25px;right:25px;transform-origin:bottom right;transform:scale(0.2);@media screen and (min-width:", "){transform:scale(0.35);}@media screen and (min-width:", "){transform:scale(0.5);}@media screen and (min-width:", "){transform:scale(0.4);}"], GRID_BREAKPOINT_SMALL, GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_EXTRA_LARGE);
const ChatOnlyWrapper = styled.div.withConfig({
  displayName: "PreviewBox__ChatOnlyWrapper",
  componentId: "sc-1oc2gzs-5"
})(["scale:0.7;@media screen and (min-width:", "){scale:0.7;}@media screen and (min-width:", "){scale:1;}"], GRID_BREAKPOINT_LARGE, GRID_BREAKPOINT_EXTRA_LARGE);
export default function PreviewBox({
  chatOnly
}) {
  const {
    chat: {
      accentColor,
      background,
      textColor,
      customChatName,
      welcomeMessage
    }
  } = useChatSlice();
  const widgetData = new WidgetData({
    message: new Message({
      initialMessage: welcomeMessage || I18n.text('app.chat.defaultWelcomeMessage'),
      chatHeadingConfig: buildChatHeadingConfigFromType(COMPANY, {
        customChatName
      })
    }),
    sendFrom: List(),
    coloring: ColoringRecord({
      accentColor,
      textColor,
      useDefaultColor: false
    })
  });
  const preview = /*#__PURE__*/_jsx(ChatWidgetPreview, {
    showingHsBranding: false,
    widgetData: widgetData,
    mobile: false,
    size: "default"
  });
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(Container, {
      chatOnly: chatOnly,
      children: /*#__PURE__*/_jsx(Wrapper, {
        chatOnly: chatOnly,
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          justifyContent: "center",
          blockSize: "100%",
          children: chatOnly ? /*#__PURE__*/_jsx(ChatOnlyWrapper, {
            children: preview
          }) :
          /*#__PURE__*/
          // @bend-expect trellis-tokenized
          _jsxs(Browser, {
            children: [background && /*#__PURE__*/_jsx(Website, {
              src: background
            }), /*#__PURE__*/_jsx(BrowserChatWrapper, {
              children: preview
            })]
          })
        })
      })
    })
  );
}